<template>
  <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
    <div class="top">
      <el-row class="content-bottom-padded" :gutter="20">
        <el-col :span="20">
          <category-select style="width:100%" distributors @update="storeSearch"
                           :shopIdDefault="distributor_id"></category-select>
          <el-input style="width:20%" size="mini" placeholder="请输入商品名称或者货号" v-model="params.keywords">
            <el-button slot="append" icon="el-icon-search" @click="goodsNumberSearch"></el-button>
          </el-input>
          <el-button type="primary" size="mini" @click="syncAction()">发布选中的商品</el-button>
          <el-button type="primary" size="mini" @click="batchSyncAction()">批量发布商品至标签店铺</el-button>
        </el-col>
      </el-row>
    </div>
    <el-tab-pane label="发布商品" name="relmall">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-table :data="list" style="width: 100%" :height="wheight-100" v-loading="loading" ref="multipleItemsTable"
                  @selection-change="handleItemsSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="item_bn" label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.pics[0]" style="width:50px;" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="item_name" label="商品名称"></el-table-column>
          <el-table-column prop="item_bn" label="商品货号">
            <template slot-scope="scope">
              {{ scope.row.item_bn }}
            </template>
          </el-table-column>

          <el-table-column prop="price" label="商品价格" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.price }}元
            </template>
          </el-table-column>
          <el-table-column label="库存" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.store }}
            </template>
          </el-table-column>
        </el-table>
        <div class="content-padded content-center">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="params.page"
            :page-sizes="[10,20,50,100]"
            :total="total_count"
            :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>
    </el-tab-pane>
    <el-dialog :title="publishtitle" :visible.sync="publishItemVisible" :before-close="handleCancel">
      <template>
          <h4 style="color:red;text-align: center;">
            发布商品至当前店铺，默认初始化为未分类数据，但不会覆盖已发布的商品。
          </h4>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="publishItemVisible = false">取消</el-button>
        <el-button type="primary" @click="addStore()" :loading="submitLoading">
          {{ submitLoading ? '发布中' : '确认开始发布' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量发布商品至标签店铺" :visible.sync="publishItemToDistributorsVisible" :before-close="handleCancel">
      <template>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="指定店铺标签">
            <el-select v-model="distributor_tag_ids" multiple size="medium" placeholder="店铺标签">
              <el-option
                v-for="item in distributor_tags"
                :key="item.tag_id"
                :label="item.tag_name"
                :value="item.tag_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

      </template>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="publishItemToDistributorsVisible = false">取消</el-button>
        <el-button type="primary" @click="batchSyncItems()" :loading="submitLoading">
          {{ submitLoading ? '发布中' : '确认开始发布' }}
        </el-button>
      </div>
    </el-dialog>
  </el-tabs>
</template>

<script>
import {
  getItemsList
} from '../../../api/goods'
import {
  addStoreDistributorItemsNew,
  addItemsToDistributors,
  getTagList
} from '../../../api/marketing'
import categorySelect from '@/components/categorySelect'
import {mapGetters} from 'vuex'

export default {
  components: {
    categorySelect
  },
  props: {
    distributorId: {
      type: String,
      default: ''
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      publishtitle: '发布商品',
      activeName: 'relmall',
      shopself_status: true,
      relmall_status: false,
      delongstatus: false,
      publishItemVisible: false,
      publishItemToDistributorsVisible: false,
      loading: false,
      submitLoading: false,
      formloading: false,
      distributor_id: '',
      SynchroRow: {},
      checkAll: false,
      itemsChecked: '',
      isSyncItems: false,
      isSyncDistributors: false,
      selectItems: [],
      checkedCities: [],
      DistributorList: [],
      distributor_tag_ids: [],
      distributor_tags: [],
      total_count: 0,
      isIndeterminate: true,
      params: {
        page: 1,
        pageSize: 10,
        keywords: '',
        item_type: 'normal',
        category: 0,
        is_warning: false
      },
      form: [],
      tag_ids: [],
      list: []
    }
  },
  methods: {
    offstore(row) {
      this.checkedCities = []
      this.SynchroRow.item_id = row.item_id
      this.delongstatus = true
    },
    ondialog() {
      this.delongstatus = false
    },
    handleClick() {

    },
    handleCancel() {
      this.publishItemVisible = false
    },
    handleCurrentChange() {
      this.getList()
    },
    handleSizeChange(pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getList()
    },
    goodsNumberSearch() {
      this.getList()
    },
    syncAction() {
      if (this.itemsChecked == '') {
        this.$message({
          type: 'error',
          message: '请选择商品',
          duration: 1000
        })
        return false
      }
      if (this.distributor_id == '') {
        this.$message({
          type: 'error',
          message: '请选择店铺',
          duration: 1000
        })
        return false
      }
      this.publishItemVisible = true
    },
    addStore() {
      this.formloading = true
      let postData = {
        distributor_id: this.distributor_id,
        item_ids: this.itemsChecked
      }
      addStoreDistributorItemsNew(postData).then(response => {
        if (response.data.data.status) {
          this.$message({
            type: 'success',
            message: '发布成功,请前往店铺商品管理查看'
          })
          this.submitLoading = false
          this.publishItemVisible = false
        }
      })
    },
    batchSyncAction () {
      this.publishItemToDistributorsVisible = true
    },
    batchSyncItems () {
      if (this.distributor_id === '') {
        this.$message({
          type: 'error',
          message: '请选择店铺',
          duration: 1000
        })
        return false
      }
      let postData = {
        isSyncItems: false,
        nowDistributorId: this.distributor_id,
        distributor_tag_ids: this.distributor_tag_ids,
        selectItems: this.itemsChecked
      }
      addItemsToDistributors(postData).then(response => {
        if (response.data.data.status === 1) {
          this.$message({
            type: 'success',
            message: '发布成功,请前往店铺商品管理查看'
          })
          this.submitLoading = false
          this.publishItemToDistributorsVisible = false
        } else {
          this.$message({
            type: 'error',
            message: response.data.data.msg
          })
          this.submitLoading = false
          this.publishItemToDistributorsVisible = false
        }
      })
    },
    getDistributorTagList() {
      getTagList({"page": 1, "pageSize": -1}).then(res => {
        this.distributor_tags = res.data.data.list
      })
    },
    handleItemsSelectionChange(val) { // 商品选择
      var arr = []
      for (var i = 0; i < val.length; i++) {
        arr.push(val[i].item_id)
      }
      this.itemsChecked = arr
    },
    storeSearch(val) {
      val && val.shop_id
      this.distributor_id = val.shop_id
    },
    getList() {
      this.loading = true
      getItemsList(this.params).then(response => {
        if (response.data.data.list) {
          this.list = response.data.data.list
          for (var i = 0; i < this.list.length; i++) {
            this.list[i].price = this.list[i].price / 100
          }
          this.total_count = parseInt(response.data.data.total_count)
        }
        this.loading = false
      })
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  mounted() {
    this.getDistributorTagList()
    this.getList()
    this.distributor_id = localStorage.getItem('DisID')
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// itemrelease.vue?4ae1d3c4